/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Sep-22
 *
 * bestgob-client - general.api.js
 **/

import {httpClientBackend} from "./http-client";

const verifyCurp = (curp) => httpClientBackend.get(`verify_curp/${curp}`)

/**
 * Valida el folio de un document
 *
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
const validateDocument = (data) => httpClientBackend.post('document_data', data)

export {
    verifyCurp, validateDocument
}